import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StepProgress } from './StepProgress';
import { getAllStepsStatus } from '../lib/workflowUtils';
import { useStore } from '../store';

export function WorkflowContainer({ children }: { children: React.ReactNode }) {
  const { currentPage, setCurrentPage, fileData, axes, scaleMapping, analysisResults } = useStore();
  const [steps, setSteps] = useState(getAllStepsStatus());

  // Recalculate steps whenever store changes OR when page changes
  useEffect(() => {
    setSteps(getAllStepsStatus());
  }, [currentPage, fileData, axes, scaleMapping, analysisResults]);

  // Filter out non-workflow pages (instructions, user_management)
  const workflowSteps = steps.filter(step => 
    !['instructions', 'user_management'].includes(step.id)
  );

  const handleStepClick = (stepId: string) => {
    const step = steps.find(s => s.id === stepId);
    if (step && step.enabled) {
      setCurrentPage(stepId);
    }
  };

  return (
    <div>
      <StepProgress steps={workflowSteps} onStepClick={handleStepClick} />
      <AnimatePresence mode="wait">
        <motion.div
          key={currentPage}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
